const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001'

export async function apiFetch(url: string, options?: RequestInit): Promise<Response> {
  const fullUrl = url.startsWith('/') ? `${API_URL}${url}` : url
  return fetch(fullUrl, options)
}
